module.exports = { id: "actieradius", url: "/build/app/img/symbols.svg#actieradius", viewBox: "", toString: function() { return this.url; } };